import React, { useEffect, useState } from "react";

import {
  Breadcrumb,
  Button,
  Input,
  message,
  PageHeader,
  Select,
  Form,
  Row,
  Col,
  Popconfirm,
  Checkbox,
  Drawer,
  Table,
  InputNumber,
  Space,
  Spin,
} from "antd";
import { DownloadOutlined } from "@ant-design/icons";

import { Link } from "react-router-dom";
import Page from "_components/Page";
import TabMenu from "./TabMenu";
import { materialTypeService } from "_services";
import { documentService } from "_services/document.service";

function Documents({ match, history }) {
  const { id } = match.params;
  const { path } = match;

  const [isLoading, setIsLoading] = useState(false);
  const [stockType, setStockType] = useState({});
  const [documentItems, setDocumentItems] = useState([]);
  const [downloading, setDownloading] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);

  useEffect(() => {
    setLoading(true);
    materialTypeService
      .getDocuments(id)
      .then((x) => {
        setDocumentItems(x.content);
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        setError(error);
      });
  }, []);

  const handleDownloadFile = (documentObj) => {
    setDownloading(true);
    documentService
      .downloadDocument(documentObj.id)
      .then((response) => {
        const url = window.webkitURL.createObjectURL(new Blob([response]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `${documentObj.documentName}`);
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
        setDownloading(false);
      })
      .catch((error) => {
        setDownloading(false);
        setError(error);
      });
  };

  const getLineColumns = () => {
    let columns = [];

    columns.push({
      title: "Created Date",
      dataIndex: "createdDate",
      key: "date",
      //width: "20%",
      render: (text, record) => {
        if (record) {
          return `${record?.createdDate ?? ""}`;
        }
      },
    });
    columns.push({
      title: "Document Name",
      dataIndex: "documentName",
      key: "name",
      //width: "20%",
      render: (text, record) => {
        if (record) {
          return `${record?.documentName ?? ""}`;
        }
      },
    });

    columns.push({
      title: "Document Type",
      dataIndex: "documentType",
      key: "type",
      //width: "20%",
      render: (text, record) => {
        if (record) {
          return `${record?.documentType ?? ""}`;
        }
      },
    });

    columns.push({
      title: "",
      key: "downloadFile",
      render: (text, record) => (
        <Button
          icon={<DownloadOutlined />}
          title="Download Document"
          type="link"
          style={{ marginRight: 10 }}
          loading={downloading}
          onClick={() => handleDownloadFile(record)}
        ></Button>
      ),
    });

    return columns;
  };

  return (
    <PageHeader
      title={
        <Breadcrumb>
          <Breadcrumb.Item>
            <Link to="/dashboard">Dashboard</Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <Link to="/bom/boms">BOM</Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <Link to={`${path}`}> Documents</Link>
          </Breadcrumb.Item>
        </Breadcrumb>
      }
      //Add buttons in the page header
      // extra={getActionButtons()}
    >
      <Page inner>
        <Spin tip="Loading..." spinning={isLoading}>
          <TabMenu menu="documents" id={id} />

          <Col span={6}></Col>
          <Col span={6}></Col>

          {documentItems && (
            <Table
              bordered
              pagination={false}
              columns={getLineColumns()}
              dataSource={documentItems}
              size="small"
            />
          )}
        </Spin>
      </Page>
    </PageHeader>
  );
}

export default Documents;
